import apiService from "../../../../service/Api";

export interface SEOConfigApiItem {
  id: number;
  company: {
    id: number;
    name: string;
  };
  page_name: string;
  meta_title_template: string;
  meta_keywords: string;
  meta_description_template: string;
  og_title_template: string | null;
  og_type: string;
  og_description_template: string | null;
  og_image_url: string | null;
  twitter_card_type: string;
  twitter_site: string | null;
  twitter_creator: string | null;
  canonical_url_pattern: string | null;
  robots_meta: string;
  is_active?: boolean;
  created_at: string;
  updated_at: string;
  created_by: number;
  last_updated_by: number | null;
}

export interface SEOConfigsApiResponse {
  results: SEOConfigApiItem[];
  count: number;
  next: string | null;
  previous: string | null;
}

export interface CreateSEOConfigData {
  page_name: string;
  meta_title_template: string;
  meta_keywords: string;
  meta_description_template: string;
  og_title_template?: string | null;
  og_type?: string;
  og_description_template?: string | null;
  og_image_url?: string | null;
  twitter_card_type?: string;
  twitter_site?: string | null;
  twitter_creator?: string | null;
  canonical_url_pattern?: string | null;
  robots_meta?: string;
  is_active?: boolean;
}

export interface UpdateSEOConfigData {
  page_name?: string;
  meta_title_template?: string;
  meta_keywords?: string;
  meta_description_template?: string;
  og_title_template?: string | null;
  og_type?: string;
  og_description_template?: string | null;
  og_image_url?: string | null;
  twitter_card_type?: string;
  twitter_site?: string | null;
  twitter_creator?: string | null;
  canonical_url_pattern?: string | null;
  robots_meta?: string;
  is_active?: boolean;
}

export const fetchSEOConfigs = () => {
  return apiService.get<SEOConfigsApiResponse>("/api/configurations/seo-configs/");
};

export const fetchSEOConfig = (id: number) => {
  return apiService.get<SEOConfigApiItem>(`/api/configurations/seo-configs/${id}/`);
};

export const createSEOConfig = (data: CreateSEOConfigData) => {
  return apiService.post<SEOConfigApiItem>("/api/configurations/seo-configs/", data);
};

export const updateSEOConfig = (id: number, data: UpdateSEOConfigData) => {
  return apiService.patch<SEOConfigApiItem>(
    `/api/configurations/seo-configs/${id}/`,
    data
  );
};

export const deleteSEOConfig = (id: number) => {
  return apiService.delete(`/api/configurations/seo-configs/${id}/`);
};